import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { RequireExperimentsAccess } from '~/features/onboarding/components/require-experiments-access';
import { requireFeatureGate } from '~/utils/guards';

const ExperimentsPage = lazy(() => import('~/features/experiments/pages/experiments-page'));

export const Route = createFileRoute('/_authenticated/_tenant/experiments/')({
  beforeLoad: requireFeatureGate('experiments'),
  component: () => (
    <RequireExperimentsAccess>
      <Suspense fallback={<PageSkeleton />}>
        <ExperimentsPage />
      </Suspense>
    </RequireExperimentsAccess>
  ),
});
